import { motion } from "framer-motion";
import { useLang } from "../../context/LanguageContext";

const ease = [0.22, 1, 0.36, 1];

const About = () => {
  const { isAr, t } = useLang();
  return (
    <section
      id="about"
      className="relative bg-bg-ivory py-[120px] md:py-[180px]"
      data-testid="about-section"
    >
      <div className="max-w-[1760px] mx-auto px-6 md:px-10 lg:px-14">
        <div className="flex justify-between items-center text-brand-green/65 mb-20">
          <span className="page-meta">— 02</span>
          <span className="page-meta">{t("نبذة عن الشركة", "About BigBrand")}</span>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.2, ease }}
          className="flex justify-end"
        >
          <img
            src={`${process.env.PUBLIC_URL}/brand/bigbrand-logotype-black.svg`}
            alt="BIGBRAND"
            className="w-full max-w-[760px] h-auto"
            draggable={false}
          />
        </motion.div>

        <div className="editorial-rule mt-10 mb-20" />

        <div className="grid grid-cols-12 gap-x-10 gap-y-12">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1, ease }}
            className="col-span-12 md:col-span-5"
          >
            <div className={`${isAr ? "label-meta-ar" : "label-meta"} text-brand-green/55 mb-6`}>
              {t("[ نبذة عن الشركة ]", "[ ABOUT US ]")}
            </div>
            <h3
              className={`${isAr ? "arabic-title" : "serif-title"} text-brand-green`}
              style={{ fontSize: isAr ? "clamp(44px, 5vw, 76px)" : "clamp(48px, 5.5vw, 92px)" }}
            >
              {isAr ? "من نحن" : (<>About <em className="font-light">Us</em></>)}
            </h3>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1, ease, delay: 0.15 }}
            className="col-span-12 md:col-span-7"
          >
            {isAr ? (
              <div className="space-y-7 max-w-[640px] arabic-title text-brand-green/85" dir="rtl" style={{ fontSize: 17, lineHeight: 1.95, fontWeight: 400 }}>
                <p>
                  تعمل BigBrand كشريك صناعي استراتيجي يدعم المشاريع الكبرى في المملكة العربية السعودية من خلال منظومة تصنيع متقدمة تشمل الأبواب والمنتجات الخشبية وحلول التشطيبات الداخلية، إلى جانب أنظمة UPVC وأبواب WPC.
                </p>
                <p>
                  تأسست BigBrand لتكون ركيزة صناعية داعمة لقطاع التشييد والبناء وشريكاً موثوقاً للمطورين والجهات الكبرى التي تتطلب قدرة إنتاجية عالية وجودة ثابتة ودقة تنفيذ والتزاماً صارماً بالمواصفات الفنية والجداول الزمنية.
                </p>
                <p>
                  وتعتمد في ذلك على قدرة تشغيلية قوية ومنهجية تنفيذ منضبطة تضمن توريداً مرحلياً موثوقاً يواكب متطلبات المشاريع الأكثر تعقيداً.
                </p>
              </div>
            ) : (
              <div className="space-y-7 max-w-[640px] text-brand-green/85" style={{ fontSize: 16.5, lineHeight: 1.85 }}>
                <p>
                  BigBrand operates as a strategic industrial partner supporting major projects across the Kingdom of Saudi Arabia through an advanced manufacturing system covering doors, wood products, interior finishing solutions, as well as UPVC systems and WPC doors.
                </p>
                <p>
                  We were established to serve as a strong industrial pillar for the construction sector and a trusted partner for developers and major entities that require high production capacity, consistent quality, execution precision, and strict compliance with technical specifications and project timelines.
                </p>
                <p>
                  This is supported by a strong operational capability and a disciplined execution model that ensures reliable phased supply aligned with the demands of the most complex projects.
                </p>
              </div>
            )}
          </motion.div>
        </div>

        <div className="editorial-rule mt-24" />
      </div>
    </section>
  );
};

export default About;
